import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeViewPaoTangVer from '@/views/HomeViewPaoTangVer.vue'
import Down50PaotangVer from '@/views/download50_PaotangVer.vue'
import CertificatePaotangVer from '@/views/certificate_PaotangVer.vue'
import PaotangCallbackView from '@/views/PaotangCallbackView.vue'
import listDownload from '@/views/DownloadListView.vue'
import abx from '@/views/AboutView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'home',
    component: HomeViewPaoTangVer
  },
  {
    path: '/download50',
    name: 'download50',
    component: Down50PaotangVer
  },
  {
    path: '/DownloadListView',
    name: 'DownloadListView',
    component: listDownload
  },
  {
    path: '/AboutView',
    name: 'AboutView',
    component: abx
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: CertificatePaotangVer
  },
  {
    path: '/paotang/callback',
    name: 'PaotangCallback',
    component: PaotangCallbackView
  },
]

const router = new VueRouter({
  mode: 'history',
    base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  next();
});
export default router
// router.replace({ path: '', redirect: '/' })
